import React from 'react';
import AssignmentModalBody from './AssignmentModalBody';
import ModalPortal from '@/components/Global/ModalPortal';
import { LessonDetails } from '@/models/LessonDetails';
import { Skill } from '@/models/Skill';
import { AmiraResources } from "@/models/AmiraResources.interface";
import './AssignmentModal.scss'
interface AssignmentModalConfig {
  searchHeader: string;
  resultsHeader: string;
  isOpen: boolean;
  isTutoring?: boolean;
  groupName: string;
  students: any[];
  skillName: string;
  onCloseHandler: () => void;
  lesson: LessonDetails;
  skillId: string;
  skill: Skill;
  skillResources: AmiraResources[];
  standards?: any;
  skillMastery?: number;
  source: string;
}

export default function AssignmentModal({
  searchHeader,
  resultsHeader,
  isOpen,
  isTutoring,
  groupName,
  skillName,
  students,
  onCloseHandler,
  lesson,
  skillId,
  skill,
  skillResources,
  standards,
  skillMastery,
  source
}: AssignmentModalConfig) {
  return (
    <ModalPortal
      isOpen={isOpen}
      onClose={onCloseHandler}
      size="content"
      overlayKeysCloseOverride={true}
      style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 'none' }}
    >
      <AssignmentModalBody
        onCloseHandler={onCloseHandler}
        resultsHeader={resultsHeader}
        isTutoring={isTutoring}
        searchHeader={searchHeader}
        students={students}
        groupName={groupName}
        skillName={skillName}
        lesson={lesson}
        skill={skill}
        skillId={skillId}
        skillResources={skillResources}
        standards={standards}
        skillMastery={skillMastery || 0}
        source={source}
      />
    </ModalPortal>
  )
}